{
  "title": "Créer un objectif",
  "basics": {
    "createGoalFor": "Créer un objectif pour {{whom}}",
    "household": "Famille",
    "corporation": "Entreprise",
    "applyPortfolioAtGoal": "Appliquer le portefeuille à l'objectif"
  },
  "pickPortfolio": {
    "applyPortfolio": "Appliquer le portefeuille",
    "useTheScores": "Utiliser les scores d'adéquation afin de sélectionner le niveau de risque optimal pour le portefeuille.",
    "goalSuitabilityScore": "Score d'adéquation de l'objectif",
    "someonesSuitabilityScore": "Score d'adéquation de {{name}}"
  },
  "recommendedPortfolio": "Modèle de portefeuille recommandé",
  "goalSummary": "Résumé de l'objectif",
  "pleaseReview": "Veuillez relire vos renseignements afin de vérifier leur exactitude. Vous pourrez les modifier plus tard dans la section Objectifs.",
  "continue": "Continuer",
  "createGoal": "Créer un objectif",
  "added": "Vous avez créé un nouvel objectif",
  "failed": "Échec de l'ajout d'un nouvel objectif.",
  "subAccMsg": "Relions cet objectif à un sous-compte",
  "createSubAccount": "Créer un sous-compte",
  "skipforNow": "Ignorer pour le moment",
  "tradingProcess": "Processus commercial"
}
